import { useStatusBoard } from './hooks/useStatusBoard';
import {
  StatusBoardSoilSection,
  StatusBoardStatusSection,
  ResetButton,
  StatusBoardSoilPhSection,
} from './components';

const StatusBoard = () => {
  const {
    currentSec,
    setCurrentSec,
    targetSec,
    errorTargetSec,
    currentSecAuto,
    secSmol,
    setSecSmol,
    kg,
    initialSecSmol,
    fineDrySoil,
    setFineDrySoil,
    errorSecSmol,
    handleFineDrySoil,
    errorCurrentSecHandle,
    resetData,
    isGreaterTarget,
    isMaintenanceMode,
    getMthaText,
    getMtha,
    getOptimumValue,
  } = useStatusBoard();

  return (
    <>
      <div className="border border-primitiveGrey p-8 md:py-4 md:px-4 rounded-2xl">
        <StatusBoardSoilSection
          secSmol={secSmol}
          setSecSmol={setSecSmol}
          initialSecSmol={initialSecSmol}
          errorSecSmol={errorSecSmol}
          fineDrySoil={fineDrySoil}
          setFineDrySoil={setFineDrySoil}
          handleFineDrySoil={handleFineDrySoil}
          kg={kg}
        />

        <StatusBoardStatusSection
          currentSec={currentSec}
          setCurrentSec={setCurrentSec}
          currentSecAuto={currentSecAuto}
          errorCurrentSecHandle={errorCurrentSecHandle}
          targetSec={targetSec}
          errorTargetSec={errorTargetSec}
        />

        <StatusBoardSoilPhSection
          isGreaterTarget={isGreaterTarget}
          getMthaText={getMthaText}
          getMtha={getMtha}
          getOptimumValue={getOptimumValue}
          isMaintenanceMode={isMaintenanceMode}
        />

        <ResetButton resetData={resetData} />
      </div>
    </>
  );
};

export default StatusBoard;
